import React from "react";
import { useHistory } from "react-router-dom";

function Roadmap() {
  const history = useHistory();
  return (
    <div id="story" className="Story py-5">
      <div className="container">
        <div className="storyInfo text-center mb-5">
          <h1 className="sectionHeading">
            THE
            <span> SolSurvivors GANG</span>
          </h1>
          {/* <h6>Lorem Ipsum dollar sit amet, consectetur adipisicing elit.</h6> */}

          <p className="mb-0 para">
            <span>Welcome to</span> the SolSurvivors Gang, where you gain membership access to the Gang whose benefits and
            offerings will increase over time. 
          </p>
          <a
            href="https://solsurvivorsnft.com/"
            className="btn mt-5"
            
          >
            MINT NOW!
            <i className="fas fa-chevron-right"></i>
          </a>
          {/* <p className="mb-0 para">
            amet consectetur adipisicing elit. Doloribus nihil amet quibusdam
            <span> Saepe, voluptates sequi.</span>
          </p>
          <p className="para">
            <span>Itaque ab</span> id expedita
            <span>praesentium</span>, nostrum maiores quam!
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default Roadmap;
